import { IUserOwnTractorListItem } from '../../../interfaces/OwnTractor.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

export const usersOwnTractorsApiUrl = '/users-own-tractors';

export interface IGetUsersOwnTractorsParams {
  searchParam: {
    machineApprovalStatus: string;
    isPokeEnabled: boolean;
    sort: string;
    minEngineOutputPs: number;
    maxEngineOutputPs: number;
    brand: string;
    regionDepth1: string;
    count: number;
    page?: number;
  };
}

export const getUsersOwnTractors = ({
  searchParam,
}: IGetUsersOwnTractorsParams): Promise<IUserOwnTractorListItem[]> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`${usersOwnTractorsApiUrl}?${URLSearchParams}`);
};
